export enum WebhookEvent {
  PreUserAdd = 1,
  PostUserAdd = 2,
  CrmContactCreated = 3,
  CrmContactUpdated = 4,
  GoogleContactsSync = 5,
}